export enum DialogType {
  PLAIN = 'plain',
  ERROR = 'error'
}
